<template>
  <div class="news-list-container">
    <!-- 页面标题 -->
    <h2 class="page-title">活动申请记录</h2>
    
    <ul class="news-list">
      <li v-for="(item, index) in dataList" :key="item.id || index" class="news-item-card">
        <a @click="$parent.goNav(`/activeInfo?id=${item.id}`)" class="news-link">
          <div class="news-item-content">
            <div class="news-content-left">
              <h4 class="news-title">
                <span class="title-text">{{ item.activity_name }}</span>
                <span class="status-text" :class="getStatusClass(item.state)">{{ statuType[item.state] }}</span>
              </h4>
              <p class="news-time">
                <i class="fa fa-clock-o mr-1"></i>{{ item.created_at }}
              </p>
            </div>
            <div class="news-arrow">
              <i class="fa fa-angle-right"></i>
            </div>
          </div>
        </a>
      </li>

      <li v-if="dataList.length === 0" class="empty-state">
        <div class="empty-image"></div>
        <p class="empty-text">暂无记录</p>
      </li>
    </ul>
    
    <!-- 分页控件 -->
    <div class="pagination-container" v-if="total > 0">
      <div class="pagination-info">
        共 {{ total }} 条，显示第 {{ (page-1)*pageSize + 1 }}-{{ Math.min(page*pageSize, total) }} 条
      </div>
      <div class="pagination-controls">
        <button 
          class="page-btn" 
          @click="changePage(page - 1)" 
          :disabled="page <= 1">
          <i class="fa fa-angle-left"></i> 上一页
        </button>
        <div class="page-numbers">
          <button 
            v-for="num in pageNumbers" 
            :key="num"
            class="page-number"
            :class="{ active: num === page }"
            @click="changePage(num)">
            {{ num }}
          </button>
        </div>
        <button 
          class="page-btn" 
          @click="changePage(page + 1)" 
          :disabled="page >= totalPages">
          下一页 <i class="fa fa-angle-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'applyagentList',
  data() {
    return { 
      dataList: [], 
      page: 1, 
      pageSize: 5, // 每页显示5条
      total: 0, // 总记录数
      statuType: ['0未约定', '待审核', '通过', '拒绝', '4未约定'] 
    };
  },
  computed: {
    // 总页数
    totalPages() {
      return Math.ceil(this.total / this.pageSize);
    },
    // 分页显示的页码
    pageNumbers() {
      const pages = [];
      const total = this.totalPages;
      let current = this.page;
      
      // 始终显示第一页
      pages.push(1);
      
      // 当总页数大于5时，只显示当前页附近的页码
      if (total > 5) {
        // 显示当前页前2页
        if (current > 3) pages.push('...');
        if (current > 2) pages.push(current - 2);
        if (current > 1) pages.push(current - 1);
        
        // 显示当前页（如果不是第一页）
        if (current !== 1 && current !== total) pages.push(current);
        
        // 显示当前页后2页
        if (current < total) pages.push(current + 1);
        if (current < total - 1) pages.push(current + 2);
        
        // 显示最后一页
        if (current < total - 2) pages.push('...');
        if (total !== 1) pages.push(total);
      } else {
        // 总页数小于等于5时，显示所有页码
        for (let i = 2; i <= total; i++) {
          pages.push(i);
        }
      }
      
      return pages;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$parent.showLoading();
      this.$apiFun.post('/api/activityApplyLog', { 
        page: this.page, 
        limit: this.pageSize 
      })
        .then(res => {
          if (res.code != 200) {
            this.$parent.showTost(0, res.message);
          } else {
            this.dataList = res.data.data;
            this.total = res.data.total; // 假设接口返回总记录数
          }
          this.$parent.hideLoading();
        })
        .catch(() => {
          this.$parent.hideLoading();
        });
    },
    
    // 切换页码
    changePage(num) {
      // 处理省略号的情况
      if (num === '...') return;
      
      // 边界检查
      if (num < 1 || num > this.totalPages) return;
      
      this.page = num;
      // 滚动到顶部
      window.scrollTo(0, 0);
      // 获取新页数据
      this.getData();
    },
    
    // 根据状态获取样式类
    getStatusClass(state) {
      switch(state) {
        case 1: // 待审核
          return 'status-pending';
        case 2: // 通过
          return 'status-approved';
        case 3: // 拒绝
          return 'status-rejected';
        default: // 未约定
          return 'status-default';
      }
    }
  },
};
</script>

<style scoped>
.news-list-container {
  background-color: #f5f7fa;
  min-height: 100vh;
  padding: 30px 15px;
  font-family: 'Helvetica', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  max-width: 1000px;
  margin: 0 auto;
}

/* 页面标题 */
.page-title {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 25px 0;
  padding-bottom: 15px;
  border-bottom: 1px solid #e2e8f0;
}

.news-list {
  list-style: none;
  padding: 0;
  margin: 0 0 30px 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.news-item-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
  overflow: hidden;
}

.news-item-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.09);
}

.news-link {
  text-decoration: none;
  display: block;
  color: inherit;
  padding: 22px 25px;
  transition: all 0.2s ease;
}

.news-link:hover {
  background-color: #f8fafc;
}

.news-item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.news-content-left {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.news-title {
  font-size: 17px;
  font-weight: 600;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.title-text {
  color: #1e293b;
  max-width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-text {
  font-size: 14px;
  font-weight: 500;
  padding: 3px 10px;
  border-radius: 12px;
  text-align: center;
  min-width: 60px;
}

/* 状态样式 */
.status-pending {
  color: #f59e0b;
  background-color: #fffbeb;
}

.status-approved {
  color: #10b981;
  background-color: #ecfdf5;
}

.status-rejected {
  color: #ef4444;
  background-color: #fee2e2;
}

.status-default {
  color: #64748b;
  background-color: #f1f5f9;
}

.news-time {
  font-size: 13px;
  color: #64748b;
  margin-top: 8px;
  display: flex;
  align-items: center;
}

.news-arrow {
  font-size: 20px;
  color: #94a3b8;
  transition: all 0.3s ease;
}

.news-link:hover .news-arrow {
  color: #3b82f6;
  transform: translateX(3px);
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  background-color: #ffffff;
  border-radius: 12px;
  margin-top: 30px;
}

.empty-image {
  background: url('/static/img/icon4.99ea03a7.99ea03a.png') no-repeat center;
  background-size: contain;
  width: 160px;
  height: 160px;
  margin: 0 auto 20px;
  opacity: 0.7;
}

.empty-text {
  color: #64748b;
  font-size: 16px;
  margin: 0;
  line-height: 1.5;
}

/* 分页样式 */
.pagination-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  margin-top: 20px;
  padding: 15px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.pagination-info {
  font-size: 14px;
  color: #64748b;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.page-btn {
  background-color: #f1f5f9;
  color: #334155;
  border: none;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  background-color: #f1f5f9;
}

.page-btn:not(:disabled):hover {
  background-color: #e2e8f0;
  transform: translateY(-2px);
}

.page-numbers {
  display: flex;
  align-items: center;
  gap: 6px;
}

.page-number {
  width: 34px;
  height: 34px;
  border-radius: 6px;
  border: none;
  background-color: #f8fafc;
  color: #334155;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.page-number.active {
  background-color: #3b82f6;
  color: white;
  font-weight: 600;
}

.page-number:not(.active):hover {
  background-color: #e2e8f0;
  transform: translateY(-2px);
}

/* 响应式 */
@media (max-width: 768px) {
  .title-text {
    max-width: 60%;
  }
}

@media (max-width: 480px) {
  .news-list-container {
    padding: 20px 10px;
  }
  
  .page-title {
    font-size: 18px;
    margin-bottom: 15px;
  }
  
  .news-link {
    padding: 18px 15px;
  }
  
  .news-title {
    font-size: 15px;
  }
  
  .title-text {
    max-width: 100%;
    white-space: normal;
    margin-bottom: 5px;
  }
  
  .status-text {
    font-size: 13px;
    padding: 2px 8px;
  }
  
  .news-time {
    font-size: 12px;
    margin-top: 5px;
  }
  
  .pagination-controls {
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .page-number {
    width: 30px;
    height: 30px;
    font-size: 13px;
  }
  
  .page-btn {
    padding: 5px 10px;
    font-size: 13px;
  }
  
  .empty-state {
    padding: 40px 10px;
  }
  
  .empty-image {
    width: 120px;
    height: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/applyagentList.vue